export {};
//# sourceMappingURL=IUnloadableComponent.js.map